<template>
   <div class="preview-warning">
      <div class="preview-text-container">
         <span
            v-for="i in 50"
            :key="i"
            class="preview-text"
         >
            PREVIEW
         </span>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
   computed: {
      ...mapGetters(['journey']),

      isPreviewMode() {
         return !!this.$route.query.preview;
      },
      isDesktop() {
         return window.innerWidth > 768;
      },
   },
};
</script>

<style scoped lang="scss">
.preview-warning {
   position: fixed;
   top: 0;
   left: 0;
   width: 100vw;
   height: 100vh;
   pointer-events: none;
   z-index: 1;
   overflow: hidden;
}

.preview-text-container {
   position: absolute;
   top: 50%;
   left: 50%;
   width: 200%;
   height: 200%;
   transform: translate(-50%, -50%) rotate(-45deg);
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-around;
   gap: 4rem;
}

.preview-text {
   font-size: 2rem;
   font-weight: bold;
   color: var(--bgColorContrast);
   opacity: 0.1;
   text-transform: uppercase;
   white-space: nowrap;
   user-select: none;

   @media (min-width: 769px) {
      font-size: 4rem;
   }
}
</style>

